import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import WixSDK from 'shared/utils/wix-sdk';

import { translations } from 'wix-vod-shared/src/common/i18n/translations';


export default class Root extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.element.isRequired,
    store: PropTypes.object.isRequired,
  };

  render() {
    const { history, routes } = this.props;

    return (
      <ReduxProvider store={this.props.store}>
        <IntlProvider messages={translations}
                      locale={WixSDK.Utils.getLocale()}>
          <Router history={history}>
            {routes}
          </Router>
        </IntlProvider>
      </ReduxProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/root.js